import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { ConfirmationService, LazyLoadEvent } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

import { ApiService, getResponse } from '../api.service';
import { Region, SelectItem, Image } from '@models';

@Injectable()
export class RegionService extends ApiService<Region> {

    protected apiGroup: string = 'shop';
	protected apiName: string = 'region';

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {
		super(http, translate, confirmationService, messageService);
	}
    
	/**
	 * getLazy(event: LazyLoadEvent)
	 */
	getLazy(event: LazyLoadEvent, fields?: Array<string>): Observable<getResponse<Region>> {
        let params: { [k: string]: any } = event;
        params.fields = ['*', 'country_nl'];

		if(fields) {
			params.fields = fields;
		}
		return this.http.post<getResponse<Region>>(
			this.getBaseUrl('get'),
			params
		).retry(this.retries);
    }
    
	/**
	 * getImages(parameters)
	 * Retrieve list of all images
     * 
     * @param regionId
	 */
	getImages(regionId: number): Observable<getResponse<Image>> {
        return this.http.get<getResponse<Image>>(
            this.getBaseUrl(regionId.toString(), 'images')
        ).retry(this.retries);
    }
    
    /**
     * uploadImage
     * Upload image to server
     * 
     * @param regionId 
     * @param image 
     */
    uploadImage(regionId: number, image: File): Observable<any> {
        const formData = new FormData();

        formData.append('image', image);

        return this.http.post<any>(
            this.getBaseUrl(regionId.toString(), 'images'),
            formData
        ).retry(this.retries);
    }

    /**
     * deleteImage
     * Delete image from server
     * 
     * @param regionId 
     * @param image_id 
     */
    deleteImage(regionId: number, image_id: number): Observable<any> {
		return  Observable.create(observer => {
			this.confirmationService.confirm({
				message: this.translate.instant("Are you sure?"),
				header: this.translate.instant("Delete " + this.apiName),
				icon: 'fa fa-trash',
                accept: () => {
					this.http.delete<any>(
						this.getBaseUrl(regionId.toString(), ['images', image_id.toString()])
					).subscribe(response => {
						if(response.success) {
							this.messageService.add({severity: 'success', summary: this.translate.instant("Delete " + this.apiName + " Image"), detail: this.translate.instant(this.apiName + " Image successfully deleted")});
						} else {
							let error = (response.error ? response.error : this.translate.instant("Unknown error occured"));
							this.messageService.add({severity: 'danger', summary: this.translate.instant("Delete " + this.apiName + " Image"), detail: error});
						}

						observer.next(response);
						observer.complete();
					}, err => {
						observer.next({
							success: false,
							error: ''
						});
						observer.complete();
					});
				},
				reject: () => {}
			});
		});
    }

	selectItemArray(): SelectItem[] {
		let array: SelectItem[] = [];

		for(var item of this.items) {
			array.push({
				label: item.name_nl,
				value: item.id
			})
		}

		return array;
	}

}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/services/shop/region.service.ts